import { useState } from "react";
import { UploadXlsxForm } from "./estilo";
import { BsUpload } from "react-icons/bs";
import { useAuth } from "../../contexts/auth";
import { toast } from "react-toastify";
import { lerPlanilha } from "../../utils/planilha/lerPlanilha";
import { baixarPlanilha } from "../../utils/planilha/baixarPlanilha";
import api from "../../services/api";
import { ErrorProdutosCampanha } from "../modals/ErrorsProdutosCampanha";

export default function UploadProdutoCampanha({
    campanha_id,
    getProdutosDaCampanha,
    produtos,
    formatosSelecionados
}){
    const { user, signOut } = useAuth();

    const [inputFile, setInputFile] = useState(null)
    const [data,setData] = useState([])
    const [erros, setErrors] = useState()
    const [loading, setLoading] = useState(false)
    const menosValidacao = formatosSelecionados.length > 1 && !formatosSelecionados.some((formato) => [6, 7, 11, 13].includes(formato?.id))
    const formatosFaixaDePreco = formatosSelecionados.filter((formato) => formato.id === 14 || formato.id === 15 || formato.id === 16).length > 0


    const enviarArquivo = async () => {
        setLoading(true)
        let arrayDeErros = []

        for(let produto of data){
            const validacaoProdutos = (
                !produto.descricao ? "Título é obrigatório" : null ||
                !produto.descricao2 ? "Subtitulo é obrigatório" : null ||
                (produto.descricao?.length > 20) || 
                (produto.descricao2?.length > 30) || 
                !menosValidacao && !produto.frase_destaque ? "Frase de destaque é obrigatório" : null ||
                produto?.frase_destaque?.length > 27 ? "Frase de destaque excedeu o limite de 27" : null ||
                produto?.frase_destaque_rodape?.length > 38 ? "Frase de destaque rodapé excedeu o limite de 38" : null ||
                produto.unidade_de_medida_promocional && produto.unidade_de_medida_promocional?.length > 10 ||
                produto?.vigencia?.length > 50 ? "Vigência excedeu o limite de 50" : null || 
                produto.precoSP && isNaN(Number(produto.precoSP)) ||
                produto.precoSP1 && isNaN(Number(produto.precoSP1)) ||
                produto.precoDF && isNaN(Number(produto.precoDF)) ||
                produto.precoDF1 && isNaN(Number(produto.precoDF1)) ||
                produto.precoGO && isNaN(Number(produto.precoGO)) ||
                produto.precoRJ && isNaN(Number(produto.precoRJ)) ||
                produto.precoRJ1 && isNaN(Number(produto.precoRJ1)) ||
                produto.preco_x_super && isNaN(Number(produto.preco_x_super)) ||
                produto.preco_regular_SP && isNaN(Number(produto.preco_regular_SP)) ||
                produto.preco_regular_SP1 && isNaN(Number(produto.preco_regular_SP1)) ||
                produto.preco_regular_DF && isNaN(Number(produto.preco_regular_DF)) ||
                produto.preco_regular_DF1 && isNaN(Number(produto.preco_regular_DF1)) ||
                produto.preco_regular_GO && isNaN(Number(produto.preco_regular_GO)) ||
                produto.preco_regular_RJ && isNaN(Number(produto.preco_regular_RJ)) ||
                produto.preco_regular_RJ1 && isNaN(Number(produto.preco_regular_RJ1)) ||
                produto.preco_regular_x_super && isNaN(Number(produto.preco_regular_x_super)) ||
                !produto.preco_regular_SP ? "Preco_regular_SP é obrigatório" : null ||
                !produto.preco_regular_DF ? "Preco_regular_DF é obrigatório" : null ||
                !produto.preco_regular_GO ? "Preco_regular_GO é obrigatório" : null ||
                !produto.preco_regular_RJ ? "Preco_regular_RJ é obrigatório" : null ||
                !produto.preco_regular_x_super ? "Preco_regular_x_super é obrigatório" : null ||
                (formatosFaixaDePreco && !produto.precoSP_faixa_de_preco1) ? "PrecoSP_faixa_de_preco1 é obrigatório" : null ||
                (formatosFaixaDePreco && !produto.precoSP1_faixa_de_preco1) ? "PrecoSP1_faixa_de_preco1 é obrigatório" : null ||
                (formatosFaixaDePreco && !produto.precoDF_faixa_de_preco1) ? "PrecoDF_faixa_de_preco1 é obrigatório" : null ||
                (formatosFaixaDePreco && !produto.precoDF1_faixa_de_preco1) ? "PrecoDF1_faixa_de_preco1 é obrigatório" : null ||
                (formatosFaixaDePreco && !produto.precoGO_faixa_de_preco1) ? "PrecoGO_faixa_de_preco1 é obrigatório" : null ||
                (formatosFaixaDePreco && !produto.precoRJ_faixa_de_preco1) ? "PrecoRJ_faixa_de_preco1 é obrigatório" : null ||
                (formatosFaixaDePreco && !produto.precoRJ1_faixa_de_preco1) ? "PrecoRJ1_faixa_de_preco1 é obrigatório" : null ||
                (formatosFaixaDePreco && !produto.preco_x_super_faixa_de_preco1) ? "Preco_x_super_faixa_de_preco1 é obrigatório" : null ||
                (formatosFaixaDePreco && !produto.precoSP_faixa_de_preco2) ? "PrecoSP_faixa_de_preco2 é obrigatório" : null ||
                (formatosFaixaDePreco && !produto.precoSP1_faixa_de_preco2) ? "PrecoSP1_faixa_de_preco2 é obrigatório" : null ||
                (formatosFaixaDePreco && !produto.precoDF_faixa_de_preco2) ? "PrecoDF_faixa_de_preco2 é obrigatório" : null ||
                (formatosFaixaDePreco && !produto.precoDF1_faixa_de_preco2) ? "PrecoDF1_faixa_de_preco2 é obrigatório" : null ||
                (formatosFaixaDePreco && !produto.precoGO_faixa_de_preco2) ? "PrecoGO_faixa_de_preco2 é obrigatório" : null ||
                (formatosFaixaDePreco && !produto.precoRJ_faixa_de_preco2) ? "PrecoRJ_faixa_de_preco2 é obrigatório" : null ||
                (formatosFaixaDePreco && !produto.precoRJ1_faixa_de_preco2) ? "PrecoRJ1_faixa_de_preco2 é obrigatório" : null ||
                (formatosFaixaDePreco && !produto.preco_x_super_faixa_de_preco2) ? "Preco_x_super_faixa_de_preco2 é obrigatório" : null ||
                (formatosFaixaDePreco && !produto.precoSP_faixa_de_preco3) ? "PrecoSP_faixa_de_preco3 é obrigatório" : null ||
                (formatosFaixaDePreco && !produto.precoSP1_faixa_de_preco3) ? "PrecoSP1_faixa_de_preco3 é obrigatório" : null ||
                (formatosFaixaDePreco && !produto.precoDF_faixa_de_preco3) ? "PrecoDF_faixa_de_preco3 é obrigatório" : null ||
                (formatosFaixaDePreco && !produto.precoDF1_faixa_de_preco3) ? "PrecoDF1_faixa_de_preco3 é obrigatório" : null ||
                (formatosFaixaDePreco && !produto.precoGO_faixa_de_preco3) ? "PrecoGO_faixa_de_preco3 é obrigatório" : null ||
                (formatosFaixaDePreco && !produto.precoRJ_faixa_de_preco3) ? "PrecoRJ_faixa_de_preco3 é obrigatório" : null ||
                (formatosFaixaDePreco && !produto.precoRJ1_faixa_de_preco3) ? "PrecoRJ1_faixa_de_preco3 é obrigatório" : null ||
                (formatosFaixaDePreco && !produto.preco_x_super_faixa_de_preco3) ? "Preco_x_super_faixa_de_preco3 é obrigatório" : null 
            ) 
            
            if(validacaoProdutos){
                arrayDeErros.push({
                    codigo: produto.codigo,
                    produto: produto.descricao,
                    erros: [
                        !produto.descricao ? "Título é obrigatório" : null,
                        !produto.descricao2 ? "Subtitulo é obrigatório" : null,
                        (produto?.descricao?.length > 20) ? "Título excedeu o limite de 20" : null, 
                        (produto?.descricao2?.length > 30) ? "Subtítulo excedeu o limite de 30" : null,
                        !menosValidacao && !produto?.frase_destaque ? "Frase de destaque é obrigatório" : null,
                        produto?.frase_destaque?.length > 27 ? "Frase de destaque excedeu o limite de 27" : null,
                        produto?.frase_destaque_rodape?.length > 38 ? "Frase de destaque rodapé excedeu o limite de 38" : null,
                        produto?.unidade_de_medida_promocional && produto.unidade_de_medida_promocional?.length > 10 ? "Unidade de medida promocional excedeu o limite de 10" : null,
                        produto?.vigencia?.length > 50 ? "Vigência excedeu o limite de 50" : null,
                        produto?.precoSP && isNaN(Number(produto.precoSP)) ? "PrecoSP não é um número" : null,
                        produto?.precoSP2 && isNaN(Number(produto.precoSP2)) ? "PrecoSP2 não é um número" : null,
                        produto?.precoSP1 && isNaN(Number(produto.precoSP1)) ? "PrecoSP não é um número" : null,
                        produto?.precoDF && isNaN(Number(produto.precoDF)) ? "PrecoDF não é um número" : null,
                        produto?.precoDF1 && isNaN(Number(produto.precoDF1)) ? "PrecoDF não é um número" : null,
                        produto?.precoGO && isNaN(Number(produto.precoGO)) ? "PrecoGO não é um número" : null,
                        produto?.precoRJ && isNaN(Number(produto.precoRJ)) ? "PrecoRJ não é um número" : null,
                        produto?.precoRJ1 && isNaN(Number(produto.precoRJ1)) ? "PrecoRJ não é um número" : null,
                        produto?.preco_x_super && isNaN(Number(produto.preco_x_super)) ? "PrecoX não é um número" : null,
                        !produto.preco_regular_SP ? "Preco_regular_SP é obrigatório" : null,
                        !produto.preco_regular_SP1 ? "Preco_regular_SP1 é obrigatório" : null,
                        !produto.preco_regular_DF ? "Preco_regular_DF é obrigatório" : null,
                        !produto.preco_regular_DF1 ? "Preco_regular_DF1 é obrigatório" : null,
                        !produto.preco_regular_GO ? "Preco_regular_GO é obrigatório" : null,
                        !produto.preco_regular_RJ ? "Preco_regular_RJ é obrigatório" : null,
                        !produto.preco_regular_RJ1 ? "Preco_regular_RJ1 é obrigatório" : null,
                        !produto.preco_regular_x_super ? "Preco_regular_x_super é obrigatório" : null,
                        (formatosFaixaDePreco && !produto.precoSP_faixa_de_preco1) ? "PrecoSP_faixa_de_preco1 é obrigatório" : null,
                        (formatosFaixaDePreco && !produto.precoSP1_faixa_de_preco1) ? "PrecoSP1_faixa_de_preco1 é obrigatório" : null,
                        (formatosFaixaDePreco && !produto.precoSP2_faixa_de_preco1) ? "PrecoSP2_faixa_de_preco1 é obrigatório" : null,
                        (formatosFaixaDePreco && !produto.precoDF_faixa_de_preco1) ? "PrecoDF_faixa_de_preco1 é obrigatório" : null,
                        (formatosFaixaDePreco && !produto.precoDF1_faixa_de_preco1) ? "PrecoDF1_faixa_de_preco1 é obrigatório" : null,
                        (formatosFaixaDePreco && !produto.precoGO_faixa_de_preco1) ? "PrecoGO_faixa_de_preco1 é obrigatório" : null,
                        (formatosFaixaDePreco && !produto.precoRJ_faixa_de_preco1) ? "PrecoRJ_faixa_de_preco1 é obrigatório" : null,
                        (formatosFaixaDePreco && !produto.precoRJ1_faixa_de_preco1) ? "PrecoRJ1_faixa_de_preco1 é obrigatório" : null,
                        (formatosFaixaDePreco && !produto.preco_x_super_faixa_de_preco1) ? "Preco_x_super_faixa_de_preco1 é obrigatório" : null,
                        (formatosFaixaDePreco && !produto.precoSP_faixa_de_preco2) ? "PrecoSP_faixa_de_preco2 é obrigatório" : null,
                        (formatosFaixaDePreco && !produto.precoSP2_faixa_de_preco2) ? "PrecoSP2_faixa_de_preco2 é obrigatório" : null,
                        (formatosFaixaDePreco && !produto.precoSP1_faixa_de_preco2) ? "PrecoSP1_faixa_de_preco2 é obrigatório" : null,
                        (formatosFaixaDePreco && !produto.precoDF_faixa_de_preco2) ? "PrecoDF_faixa_de_preco2 é obrigatório" : null,
                        (formatosFaixaDePreco && !produto.precoDF1_faixa_de_preco2) ? "PrecoDF1_faixa_de_preco2 é obrigatório" : null,
                        (formatosFaixaDePreco && !produto.precoGO_faixa_de_preco2) ? "PrecoGO_faixa_de_preco2 é obrigatório" : null,
                        (formatosFaixaDePreco && !produto.precoRJ_faixa_de_preco2) ? "PrecoRJ_faixa_de_preco2 é obrigatório" : null,
                        (formatosFaixaDePreco && !produto.precoRJ1_faixa_de_preco2) ? "PrecoRJ1_faixa_de_preco2 é obrigatório" : null,
                        (formatosFaixaDePreco && !produto.preco_x_super_faixa_de_preco2) ? "Preco_x_super_faixa_de_preco2 é obrigatório" : null,
                        (formatosFaixaDePreco && !produto.precoSP_faixa_de_preco3) ? "PrecoSP_faixa_de_preco3 é obrigatório" : null,
                        (formatosFaixaDePreco && !produto.precoSP1_faixa_de_preco3) ? "PrecoSP1_faixa_de_preco3 é obrigatório" : null,
                        (formatosFaixaDePreco && !produto.precoSP2_faixa_de_preco3) ? "PrecoSP2_faixa_de_preco3 é obrigatório" : null,
                        (formatosFaixaDePreco && !produto.precoDF_faixa_de_preco3) ? "PrecoDF_faixa_de_preco3 é obrigatório" : null,
                        (formatosFaixaDePreco && !produto.precoDF1_faixa_de_preco3) ? "PrecoDF1_faixa_de_preco3 é obrigatório" : null,
                        (formatosFaixaDePreco && !produto.precoGO_faixa_de_preco3) ? "PrecoGO_faixa_de_preco3 é obrigatório" : null,
                        (formatosFaixaDePreco && !produto.precoRJ_faixa_de_preco3) ? "PrecoRJ_faixa_de_preco3 é obrigatório" : null,
                        (formatosFaixaDePreco && !produto.precoRJ1_faixa_de_preco3) ? "PrecoRJ1_faixa_de_preco3 é obrigatório" : null,
                        (formatosFaixaDePreco && !produto.preco_x_super_faixa_de_preco3) ? "Preco_x_super_faixa_de_preco3 é obrigatório" : null,
                        produto?.preco_regular_SP && isNaN(Number(produto.preco_regular_SP)) ? "Preco_regular_SP não é um número" : null,
                        produto?.preco_regular_SP1 && isNaN(Number(produto.preco_regular_SP1)) ? "Preco_regular_SP1 não é um número" : null,
                        produto?.preco_regular_DF && isNaN(Number(produto.preco_regular_DF)) ? "Preco_regular_DF não é um número" : null,
                        produto?.preco_regular_DF1 && isNaN(Number(produto.preco_regular_DF1)) ? "Preco_regular_DF1 não é um número" : null,
                        produto?.preco_regular_GO && isNaN(Number(produto.preco_regular_GO)) ? "Preco_regular_GO não é um número" : null,
                        produto?.preco_regular_RJ && isNaN(Number(produto.preco_regular_RJ)) ? "Preco_regular_RJ não é um número" : null,
                        produto?.preco_regular_RJ1 && isNaN(Number(produto.preco_regular_RJ1)) ? "Preco_regular_RJ1 não é um número" : null,
                        (formatosFaixaDePreco && !produto.precoSP_faixa_de_preco1) && isNaN(Number(produto.precoSP_faixa_de_preco1)) ? "PrecoSP_faixa_de_preco1 não é um número" : null,
                        (formatosFaixaDePreco && !produto.precoSP2_faixa_de_preco1) && isNaN(Number(produto.precoSP2_faixa_de_preco1)) ? "PrecoSP2_faixa_de_preco1 não é um número" : null,
                        (formatosFaixaDePreco && !produto.precoSP1_faixa_de_preco1) && isNaN(Number(produto.precoSP1_faixa_de_preco1)) ? "PrecoSP1_faixa_de_preco1 não é um número" : null,
                        (formatosFaixaDePreco && !produto.precoDF_faixa_de_preco1) && isNaN(Number(produto.precoDF_faixa_de_preco1)) ? "PrecoDF_faixa_de_preco1 não é um número" : null,
                        (formatosFaixaDePreco && !produto.precoDF1_faixa_de_preco1) && isNaN(Number(produto.precoDF1_faixa_de_preco1)) ? "PrecoDF1_faixa_de_preco1 não é um número" : null,
                        (formatosFaixaDePreco && !produto.precoGO_faixa_de_preco1) && isNaN(Number(produto.precoGO_faixa_de_preco1)) ? "PrecoGO_faixa_de_preco1 não é um número" : null,
                        (formatosFaixaDePreco && !produto.precoRJ_faixa_de_preco1) && isNaN(Number(produto.precoRJ_faixa_de_preco1)) ? "PrecoRJ_faixa_de_preco1 não é um número" : null,
                        (formatosFaixaDePreco && !produto.precoRJ1_faixa_de_preco1) && isNaN(Number(produto.precoRJ1_faixa_de_preco1)) ? "PrecoRJ1_faixa_de_preco1 não é um número" : null,
                        (formatosFaixaDePreco && !produto.preco_x_super_faixa_de_preco1) && isNaN(Number(produto.preco_x_super_faixa_de_preco1)) ? "Preco_x_super_faixa_de_preco1 não é um número" : null,
                        (formatosFaixaDePreco && !produto.precoSP_faixa_de_preco2) && isNaN(Number(produto.precoSP_faixa_de_preco2)) ? "PrecoSP_faixa_de_preco2 não é um número" : null,
                        (formatosFaixaDePreco && !produto.precoSP1_faixa_de_preco2) && isNaN(Number(produto.precoSP1_faixa_de_preco2)) ? "PrecoSP1_faixa_de_preco2 não é um número" : null,
                        (formatosFaixaDePreco && !produto.precoSP2_faixa_de_preco2) && isNaN(Number(produto.precoSP2_faixa_de_preco2)) ? "PrecoSP2_faixa_de_preco2 não é um número" : null,
                        (formatosFaixaDePreco && !produto.precoDF_faixa_de_preco2) && isNaN(Number(produto.precoDF_faixa_de_preco2)) ? "PrecoDF_faixa_de_preco2 não é um número" : null,
                        (formatosFaixaDePreco && !produto.precoDF1_faixa_de_preco2) && isNaN(Number(produto.precoDF1_faixa_de_preco2)) ? "PrecoDF1_faixa_de_preco2 não é um número" : null,
                        (formatosFaixaDePreco && !produto.precoGO_faixa_de_preco2) && isNaN(Number(produto.precoGO_faixa_de_preco2)) ? "PrecoGO_faixa_de_preco2 não é um número" : null,
                        (formatosFaixaDePreco && !produto.precoRJ_faixa_de_preco2) && isNaN(Number(produto.precoRJ_faixa_de_preco2)) ? "PrecoRJ_faixa_de_preco2 não é um número" : null,
                        (formatosFaixaDePreco && !produto.precoRJ1_faixa_de_preco2) && isNaN(Number(produto.precoRJ1_faixa_de_preco2)) ? "PrecoRJ1_faixa_de_preco2 não é um número" : null,
                        (formatosFaixaDePreco && !produto.preco_x_super_faixa_de_preco2) && isNaN(Number(produto.preco_x_super_faixa_de_preco2)) ? "Preco_x_super_faixa_de_preco2 não é um número" : null,
                        (formatosFaixaDePreco && !produto.precoSP_faixa_de_preco3) && isNaN(Number(produto.precoSP_faixa_de_preco3)) ? "PrecoSP_faixa_de_preco3 não é um número" : null,
                        (formatosFaixaDePreco && !produto.precoSP1_faixa_de_preco3) && isNaN(Number(produto.precoSP1_faixa_de_preco3)) ? "PrecoSP1_faixa_de_preco3 não é um número" : null,
                        (formatosFaixaDePreco && !produto.precoSP2_faixa_de_preco3) && isNaN(Number(produto.precoSP2_faixa_de_preco3)) ? "PrecoSP2_faixa_de_preco3 não é um número" : null,
                        (formatosFaixaDePreco && !produto.precoDF_faixa_de_preco3) && isNaN(Number(produto.precoDF_faixa_de_preco3)) ? "PrecoDF_faixa_de_preco3 não é um número" : null,
                        (formatosFaixaDePreco && !produto.precoDF1_faixa_de_preco3) && isNaN(Number(produto.precoDF1_faixa_de_preco3)) ? "PrecoDF1_faixa_de_preco3 não é um número" : null,
                        (formatosFaixaDePreco && !produto.precoGO_faixa_de_preco3) && isNaN(Number(produto.precoGO_faixa_de_preco3)) ? "PrecoGO_faixa_de_preco3 não é um número" : null,
                        (formatosFaixaDePreco && !produto.precoRJ_faixa_de_preco3) && isNaN(Number(produto.precoRJ_faixa_de_preco3)) ? "PrecoRJ_faixa_de_preco3 não é um número" : null,
                        (formatosFaixaDePreco && !produto.precoRJ1_faixa_de_preco3) && isNaN(Number(produto.precoRJ1_faixa_de_preco3)) ? "PrecoRJ1_faixa_de_preco3 não é um número" : null,
                        (formatosFaixaDePreco && !produto.preco_x_super_faixa_de_preco3) && isNaN(Number(produto.preco_x_super_faixa_de_preco3)) ? "Preco_x_super_faixa_de_preco3 não é um número" : null,
                    ]
                })                
            }
        }
  
        if(arrayDeErros.length > 0){
            setLoading(false)
            return setErrors(arrayDeErros)
        }

        if (data){
            try {
                await api.patch(`/campanhas/${campanha_id}/produtos`,
                    {
                        produtos: data,
                        usuario_id: user.id_usuario
                    },
                    {
                        headers: { 'Authorization': user.token },
                    },
                )
                setLoading(false)
                await getProdutosDaCampanha();
                toast.success('Produtos atualizados com sucesso')
            } catch (error) {
                setLoading(false)
                if(error.response.status === 401) signOut();
    
                if (error.response.data?.messages){
                    const erros = error.response.data.messages
                    erros.forEach((erro) => {
                        toast.error(erro)
                    })
                } else {
                    if(error.response.data?.error === "Produtos não encontrados!"){                        
                        error.response.data?.produtosNaoEncontrados.forEach((produto) => {
                        arrayDeErros.push({
                            codigo: produto.codigo,
                            produto: produto.descricao,
                            erros: [
                                "Código não encontrado entre seus produtos cadastrados. Cadastre o produto ou remova a linha da planilha."
                            ]
                        });
                    })

                        setErrors(arrayDeErros)
                    }

                    toast.error(error.response.data?.error || 'Erro ao atualizar produtos')
                }
            }
        }
    }

    const planilhaExemplo = () => {
        baixarPlanilha({
            nomeDoArquivo: 'exemplo_produtos_campanha.xlsx',
            abas: [{
                nome: 'produtos da campanha',
                dados: [{
                    codigo: '123456',
                    titulo: 'titulo de exemplo',
                    subtitulo: 'subtitulo de exemplo',
                    frase_destaque: 'frase de destaque de exemplo',
                    frase_destaque_rodape: 'frase de destaque de exemplo',
                    unidade_de_medida_promocional: 'unidade de medida de exemplo',
                    vigencia: 'Produto válido até 15/08',
                    preco_regular_SP: '',
                    precoSP: '10.00',
                    precoSP_faixa_de_preco1: '',
                    precoSP_faixa_de_preco2: '',
                    precoSP_faixa_de_preco3: '',
                    preco_regular_SP1: '',
                    precoSP1: '10.00',
                    precoSP1_faixa_de_preco1: '',
                    precoSP1_faixa_de_preco2: '',
                    precoSP1_faixa_de_preco3: '',
                    preco_regular_SP2: '',
                    precoSP2: '10.00',
                    precoSP2_faixa_de_preco1: '',
                    precoSP2_faixa_de_preco2: '',
                    precoSP2_faixa_de_preco3: '',
                    preco_regular_DF: '',
                    precoDF: '20.00',
                    precoDF_faixa_de_preco1: '',
                    precoDF_faixa_de_preco2: '',
                    precoDF_faixa_de_preco3: '',
                    preco_regular_DF1: '',
                    precoDF1: '25.00',
                    precoDF1_faixa_de_preco1: '',
                    precoDF1_faixa_de_preco2: '',
                    precoDF1_faixa_de_preco3: '',
                    preco_regular_GO: '',
                    precoGO: '25.00',
                    precoGO_faixa_de_preco1: '',
                    precoGO_faixa_de_preco2: '',
                    precoGO_faixa_de_preco3: '',
                    preco_regular_RJ: '',
                    precoRJ: '15.00',
                    precoRJ_faixa_de_preco1: '',
                    precoRJ_faixa_de_preco2: '',
                    precoRJ_faixa_de_preco3: '',
                    preco_regular_RJ1: '',
                    precoRJ1:'16.00',
                    precoRJ1_faixa_de_preco1: '',
                    precoRJ1_faixa_de_preco2: '',
                    precoRJ1_faixa_de_preco3: '',
                    preco_regular_x_super: '',
                    preco_x_super: '14.00',
                    preco_x_super_faixa_de_preco1: '',
                    preco_x_super_faixa_de_preco2: '',
                    preco_x_super_faixa_de_preco3: '',
                }],
            }],
        })
    }

    const baixarRelatorio = () => {
        baixarPlanilha({
            nomeDoArquivo: 'relatorio_produtos_campanha.xlsx',
            abas: [{
                nome: 'produtos da campanha',
                dados: produtos.map((produto) => ({
                    id: produto.id,
                    codigo: produto.codigo,
                    produto: produto.produto,
                    categoria: produto.categoria,
                    titulo: produto.descricao,
                    subtitulo: produto.descricao2,
                    frase_destaque: produto.frase_destaque,
                    unidade_de_medida_promocional: produto.unidade_de_medida_promocional,
                    vigencia: produto.vigencia,
                    status: produto.status,
                    preco_regular_SP: produto.preco_regular_SP,
                    precoSP: produto.precoSP,
                    preco_regular_SP1: produto.preco_regular_SP1,
                    precoSP1: produto.precoSP1,
                    preco_regular_DF: produto.preco_regular_DF,
                    precoDF: produto.precoDF,
                    preco_regular_DF1: produto.preco_regular_DF1,
                    precoDF1: produto.precoDF1,
                    preco_regular_GO: produto.preco_regular_GO,
                    precoGO: produto.precoGO,
                    preco_regular_RJ: produto.preco_regular_RJ,
                    precoRJ: produto.precoRJ,
                    preco_regular_RJ1: produto.preco_regular_RJ1,
                    precoRJ1: produto.precoRJ1,
                    preco_regular_x_super: produto.preco_regular_x_super,
                    preco_x_super: produto.preco_x_super
                })),
            }],
        })
    }

    const baixarProdutos = async () => {
        try {
            const resposta = await api.get('/produtos',
                {
                    headers:{
                        'Authorization':user.token
                    }
                }
            )

            baixarPlanilha({
                nomeDoArquivo: 'produtos.xlsx',
                abas: [{
                    nome: 'produtos',
                    dados: resposta.data.produtos.filter(produto => produto.status === 'ATIVO').map((produto) => ({
                        codigo: produto.codigo,
                        produto: produto.produto,
                        categoria: produto.categoria,
                        titulo: produto.descricao,
                        subtitulo: produto.descricao2,
                        frase_destaque: produto.frase_destaque,
                        unidade_de_medida_promocional: produto.unidade_de_medida_promocional,
                        preco_regular_SP: "",
                        precoSP: produto.precoSP,
                        preco_regular_SP1: "",
                        precoSP1: produto.precoSP1,
                        preco_regular_DF: "",
                        precoDF: produto.precoDF,
                        preco_regular_DF1: "",
                        precoDF1: produto.precoDF1,
                        preco_regular_GO: "",
                        precoGO: produto.precoGO,
                        preco_regular_RJ: "",
                        precoRJ: produto.precoRJ,
                        preco_regular_RJ1: "",                        
                        precoRJ1: produto.precoRJ1,
                        preco_regular_x_super: produto.preco_regular_x_super,
                        preco_x_super: produto.preco_x_super
                    })),
                }],
            })
        }
        catch (error) {
            if(error.response.status === 401) signOut();
    
            toast.error(error.response.data?.error || 'Erro ao buscar produtos')
        }
    }

    const formatarPlanilha = (json = []) => {
        const todasChaves = new Set();

        json.forEach(item => {
        Object.keys(item).forEach(key => todasChaves.add(key));
        });

            const colunasObrigatorias = [
                'codigo',
                'titulo',
                'subtitulo',
                'unidade_de_medida_promocional',
                'preco_regular_SP',
                'preco_regular_SP1',
                'precoSP',
                'precoSP1',
                'preco_regular_DF',
                'preco_regular_DF1',
                'precoDF',
                'preco_regular_GO',
                'precoGO',
                'preco_regular_RJ',
                'preco_regular_RJ1',
                'precoRJ',
                'preco_regular_x_super',
                'preco_x_super',
                'preco_x_super',
                'precoSP_faixa_de_preco1',
                'precoSP1_faixa_de_preco1',
                'precoDF_faixa_de_preco1',
                'precoDF1_faixa_de_preco1',
                'precoGO_faixa_de_preco1',
                'precoRJ_faixa_de_preco1',
                'precoRJ1_faixa_de_preco1',
                'preco_x_super_faixa_de_preco1',
                'precoSP1_faixa_de_preco1',
                'precoDF_faixa_de_preco1',
                'precoDF1_faixa_de_preco1',
                'precoGO_faixa_de_preco1',
                'precoRJ_faixa_de_preco1',
                'precoRJ1_faixa_de_preco1',
                'preco_x_super_faixa_de_preco1',
                'precoSP_faixa_de_preco2',
                'precoSP1_faixa_de_preco2',
                'precoDF_faixa_de_preco2',
                'precoDF1_faixa_de_preco2',
                'precoGO_faixa_de_preco2',
                'precoRJ_faixa_de_preco2',
                'precoRJ1_faixa_de_preco2',
                'preco_x_super_faixa_de_preco2',
                'precoSP_faixa_de_preco3',
                'precoSP1_faixa_de_preco3',
                'precoDF_faixa_de_preco3',
                'precoDF1_faixa_de_preco3',
                'precoGO_faixa_de_preco3',
                'precoRJ_faixa_de_preco3',
                'precoRJ1_faixa_de_preco3',
                'preco_x_super_faixa_de_preco3',
            ];
        
            // Verifica se a primeira linha possui todas as colunas obrigatórias
            const primeiraLinha = json.reduce((maisCompleto, itemAtual) => {
                return Object.keys(itemAtual).length > Object.keys(maisCompleto).length
                  ? itemAtual
                  : maisCompleto;
              }, {});
            
            const colunasArquivo = Object.keys(primeiraLinha || {});
            const colunasFaltando = colunasObrigatorias.filter(coluna => !colunasArquivo.includes(coluna));

        
            if (colunasFaltando.length > 0) {
                return setErrors([
                    {
                        codigo: "Cabeçalho",
                        produto: colunasFaltando.join(", "),
                        erros: [
                            "Essas colunas ou valores obrigatórias estão ausentes"
                        ]
                    }
                ]);
            }
    
        const produtosFormatados = json.map((produto) => {
            const resultado = {};
            for (let chave in produto) {
                const valor = String(produto[chave]);
                if (chave === 'titulo') chave = 'descricao';
                if (chave === 'subtitulo') chave = 'descricao2';
                resultado[chave] = valor.trim();
            }
            return resultado;
        });
    
        setData(produtosFormatados);
    }

    if(loading){
        return(
            <div className='modalPrecificador'>
                <div className='modalPrecificador-container'>
                    <h1>Carregando...</h1>
                </div>
            </div>
        )
    }

    return (
        <UploadXlsxForm>
            <div className="container">
                <h6 title="Import para atualizar os produtos">IMPORTAR PARA CRIAR OU ATUALIZAR OS PRODUTOS</h6>
                <div className="input-container">
                    <label htmlFor="arquivo-xlsx">
                        <BsUpload />
                    </label>
                    <p>{inputFile ? inputFile : 'Escolher arquivo'}</p>
                    <input 
                        id="arquivo-xlsx"
                        type="file"
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        onChange={(e) => {
                            if (e.target.files) setInputFile(e.target.files[0].name)
                            lerPlanilha(formatarPlanilha)(e)
                        }}
                        onClick={(e) => {
                            e.target.value = null
                            setInputFile(null)
                            setData([])
                        }}
                        placeholder="Selecione um arquivo"
                    />
                </div>
                <div className="button-container">
                    <button
                        type='button' 
                        className="exemplo"
                        onClick={planilhaExemplo}
                    >MODELO PARA CADASTRO</button>
                    <button
                        type='button' 
                        title="Atualizar produtos da campanha"
                        className="enviar"
                        onClick={enviarArquivo}
                        disabled={!data.length}
                    >ENVIAR</button>
                </div>
                <h6 title="Relatórios">EXTRAÇÃO DE RELATÓRIOS</h6>
                <div className="button-container">
                    <button
                        type='button' 
                        className="relatorio"
                        onClick={baixarRelatorio}
                        disabled={!produtos.length}
                    >PRODUTOS CAMPANHA</button>
                    <button
                        type='button' 
                        className="relatorio"
                        onClick={baixarProdutos}
                    >PRODUTOS CADASTRADOS</button>
                </div>
            </div>
            {erros && <ErrorProdutosCampanha erros={erros} setErros={setErrors}/>}
        </UploadXlsxForm>
    )
}